import { useMemo } from "react";
import { useTranslation } from "@/langs/useTranslation";
import SingleSelector from "../SingleSelector";
import ChipStatus from "../ChipStatus";

const useTargetTypeOptions = () => {
  const { t } = useTranslation();

  return [
    { id: 1, name: t({ defaultMessage: "门店" }) },
    { id: 2, name: t({ defaultMessage: "标签" }) },
    { id: 0, name: t({ defaultMessage: "设备" }) }
  ];
};

const TargetType = ({ name, value, onChange }) => {
  const { t } = useTranslation();
  const options = useTargetTypeOptions();

  return (
    <SingleSelector
      placeholder={t({ defaultMessage: "目标类型" })}
      clearable
      options={options}
      name={name}
      value={value}
      onChange={onChange}
    />
  );
};

export const TargetTypeChipStatus = ({ status }) => {
  const options = useTargetTypeOptions();
  const option = useMemo(() => {
    return options.find(option => option.id === status);
  }, [status]);

  return <ChipStatus type="default" label={option?.name} />;
};

export default TargetType;
